module.exports = __webpack_public_path__ + "69962f502db13ff153b42f67055e8951.svg";